<mat-form-field>
    <mat-date-range-input [rangePicker]="picker">

        <input #startDate readonly matStartDate [value]="selectedDateStart" (click)="picker.open()"
            (dateChange)="startDatePicker$.next($event)">

        <input #endDate readonly matEndDate [value]="selectedDateEnd" (click)="picker.open()"
            (dateChange)="endDatePicker$.next($event)">

    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
</mat-form-field>